import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all translation files
import enCommon from '../locales/en/common.json';
import enHomepage from '../locales/en/homepage.json';
import enMeta from '../locales/en/meta.json';
import enProduct from '../locales/en/product.json';
import enCart from '../locales/en/cart.json';
import enCheckout from '../locales/en/checkout.json';
import enBlog from '../locales/en/blog.json';
import enFooter from '../locales/en/footer.json';
import enNavigation from '../locales/en/navigation.json';
import enCatalog from '../locales/en/catalog.json';
import enSearch from '../locales/en/search.json';
import enAccount from '../locales/en/account.json';
import enRecipe from '../locales/en/recipe.json';

import deCommon from '../locales/de/common.json';
import deHomepage from '../locales/de/homepage.json';
import deMeta from '../locales/de/meta.json';
import deProduct from '../locales/de/product.json';
import deCart from '../locales/de/cart.json';
import deCheckout from '../locales/de/checkout.json';
import deBlog from '../locales/de/blog.json';
import deFooter from '../locales/de/footer.json';
import deNavigation from '../locales/de/navigation.json';
import deCatalog from '../locales/de/catalog.json';
import deSearch from '../locales/de/search.json';
import deAccount from '../locales/de/account.json';
import deRecipe from '../locales/de/recipe.json';

import plCommon from '../locales/pl/common.json';
import plHomepage from '../locales/pl/homepage.json';
import plMeta from '../locales/pl/meta.json';
import plProduct from '../locales/pl/product.json';
import plCart from '../locales/pl/cart.json';
import plCheckout from '../locales/pl/checkout.json';
import plBlog from '../locales/pl/blog.json';
import plFooter from '../locales/pl/footer.json';
import plNavigation from '../locales/pl/navigation.json';
import plCatalog from '../locales/pl/catalog.json';
import plSearch from '../locales/pl/search.json';
import plAccount from '../locales/pl/account.json';
import plRecipe from '../locales/pl/recipe.json';

import ukCommon from '../locales/uk/common.json';
import ukHomepage from '../locales/uk/homepage.json';
import ukMeta from '../locales/uk/meta.json';
import ukProduct from '../locales/uk/product.json';
import ukCart from '../locales/uk/cart.json';
import ukCheckout from '../locales/uk/checkout.json';
import ukBlog from '../locales/uk/blog.json';
import ukFooter from '../locales/uk/footer.json';
import ukNavigation from '../locales/uk/navigation.json';
import ukCatalog from '../locales/uk/catalog.json';
import ukSearch from '../locales/uk/search.json';
import ukAccount from '../locales/uk/account.json';
import ukRecipe from '../locales/uk/recipe.json';

// Resources object
const resources = {
  en: {
    common: enCommon,
    homepage: enHomepage,
    meta: enMeta,
    product: enProduct,
    cart: enCart,
    checkout: enCheckout,
    blog: enBlog,
    footer: enFooter,
    navigation: enNavigation,
    catalog: enCatalog,
    search: enSearch,
    account: enAccount,
    recipe: enRecipe,
  },
  de: {
    common: deCommon,
    homepage: deHomepage,
    meta: deMeta,
    product: deProduct,
    cart: deCart,
    checkout: deCheckout,
    blog: deBlog,
    footer: deFooter,
    navigation: deNavigation,
    catalog: deCatalog,
    search: deSearch,
    account: deAccount,
    recipe: deRecipe,
  },
  pl: {
    common: plCommon,
    homepage: plHomepage,
    meta: plMeta,
    product: plProduct,
    cart: plCart,
    checkout: plCheckout,
    blog: plBlog,
    footer: plFooter,
    navigation: plNavigation,
    catalog: plCatalog,
    search: plSearch,
    account: plAccount,
    recipe: plRecipe,
  },
  uk: {
    common: ukCommon,
    homepage: ukHomepage,
    meta: ukMeta,
    product: ukProduct,
    cart: ukCart,
    checkout: ukCheckout,
    blog: ukBlog,
    footer: ukFooter,
    navigation: ukNavigation,
    catalog: ukCatalog,
    search: ukSearch,
    account: ukAccount,
    recipe: ukRecipe,
  },
};

i18n
  // Load translation using http backend
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,

    // Default language
    fallbackLng: 'en',

    // Active languages (Shopify supported)
    supportedLngs: ['en', 'de', 'pl', 'uk'],

    // Don't load a fallback language in dev mode
    debug: process.env.NODE_ENV === 'development',

    // Default namespace
    defaultNS: 'common',

    // Namespaces
    ns: [
      'common',
      'homepage',
      'meta',
      'product',
      'cart',
      'checkout',
      'blog',
      'footer',
      'navigation',
      'catalog',
      'search',
      'account',
      'recipe',
    ],

    // Language detection options
    detection: {
      // Order of detection methods
      order: ['path', 'localStorage', 'navigator'],

      // Path detection options
      lookupFromPathIndex: 0, // Language is first segment: /de/page
      lookupFromSubdomainIndex: 0,

      // Keys to look for in localStorage
      lookupLocalStorage: 'olispices-language',

      // Cache language in localStorage
      caches: ['localStorage'],

      // Don't cache on server
      excludeCacheFor: ['cimode'],

      // Only detect supported languages
      convertDetectedLanguage: 'Iso15897',
    },

    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Backend options for loading translations
    backend: {
      // Don't load from backend, we have local resources
      loadPath: false,
    },

    // React options
    react: {
      // Bind i18n instance
      bindI18n: 'languageChanged',
      bindI18nStore: false,
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
    },
  });

export default i18n;
